import { useSearch } from '@tanstack/react-router';

import { AdvancedError } from '../../common/Error/AdvancedError';
import { LoadingIndicator } from '../../common/LoadingIndicator/LoadingIndicator';
import { QuickStats } from '../../dashboard/common/components/QuickStats';
import { useAdminStatistics } from '../hooks/useAdminStatistics';

import { AdminStatisticsContent } from './AdminStatisticsContent';
import { AdminStatisticsTabSwitch } from './AdminStatisticsTabSwitch';
import { NoStatistics } from './NoStatistics';
import { StatisticsCenteredFrame } from './StatisticsCenteredFrame';
import { StatisticTab } from './StatisticTab';

export const AdminStatistics = () => {
    const search = useSearch({ from: '/_app/statistics' });
    const companySelected = search.customerIds.length > 0 || search.supplierIds.length > 0;
    const showQuickStats = search.tab === StatisticTab.GENERAL && !companySelected;

    const adminStatisticsQuery = useAdminStatistics({
        from: search.from,
        to: search.to,
        customerIds: search.customerIds,
        supplierIds: search.supplierIds,
    });

    const quickStatsSection = showQuickStats ? <QuickStats /> : null;

    if (adminStatisticsQuery.isPending) {
        return (
            <div>
                <AdminStatisticsTabSwitch />
                {quickStatsSection}
                <StatisticsCenteredFrame>
                    <LoadingIndicator />
                </StatisticsCenteredFrame>
            </div>
        );
    }

    if (adminStatisticsQuery.isError) {
        return (
            <StatisticsCenteredFrame>
                <AdvancedError />
            </StatisticsCenteredFrame>
        );
    }

    if (adminStatisticsQuery.data?.general.completedCount === 0) {
        return (
            <div>
                <AdminStatisticsTabSwitch />
                {quickStatsSection}
                {!showQuickStats ? (
                    <StatisticsCenteredFrame>
                        <NoStatistics />
                    </StatisticsCenteredFrame>
                ) : null}
            </div>
        );
    }

    return (
        <div>
            <AdminStatisticsTabSwitch />
            {quickStatsSection}
            <AdminStatisticsContent statistics={adminStatisticsQuery.data} />
        </div>
    );
};
